import styled from "styled-components";

export const FoldedHeaderContainer = styled.div`
  width: 100%;
  height: 49px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  padding: 0 24px;
  box-sizing: border-box;
`;
